import React, { useState, useEffect, useCallback } from "react";
import Header from "../commons/Header/Header";
import Sidebar from "../commons/Sidebar/Sidebar";
import Icon1 from "../assets/images/icons/1.svg";
import Icon2 from "../assets/images/icons/2.svg";
import Icon3 from "../assets/images/icons/3.svg";
import Icon4 from "../assets/images/icons/4.svg";
import DateRangeSelectButton from "../commons/DateRangeSelectButton/DateRangeSelectButton";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import { UI_CONSTANTS } from "../utils/constants";
import { buildDashboardQuery } from "../utils/dashboardDateRange";

const pickStat = (data, ...keys) => {
  for (const key of keys) {
    if (data?.[key] !== undefined && data?.[key] !== null) {
      return data[key];
    }
  }
  return 0;
};

const STAT_CARDS = [
  {
    title: "New Orders",
    icon: Icon2,
    keys: ["newOrders", "new_orders", "totalNewOrders", "total_new_orders"],
  },
  {
    title: "Active Customers",
    icon: Icon1,
    keys: ["activeCustomers", "active_customers", "totalActiveCustomers", "total_active_customers"],
  },
  {
    title: "Active Restaurant",
    icon: Icon3,
    keys: [
      "activeRestaurant",
      "active_restaurant",
      "activeRestaurants",
      "active_restaurants",
      "totalActiveRestaurants",
      "total_active_restaurants",
    ],
  },
  {
    title: "Active Drivers",
    icon: Icon4,
    keys: ["activeDrivers", "active_drivers", "totalActiveDrivers", "total_active_drivers"],
  },
  {
    title: "New Customers",
    icon: Icon1,
    keys: ["newCustomers", "new_customers", "totalNewCustomers", "total_new_customers"],
  },
  {
    title: "New Restaurant",
    icon: Icon3,
    keys: [
      "newRestaurant",
      "new_restaurant",
      "newRestaurants",
      "new_restaurants",
      "totalNewRestaurants",
      "total_new_restaurants",
    ],
  },
  {
    title: "Pending Restaurant Approval",
    icon: Icon3,
    keys: [
      "pendingRestaurantApproval",
      "pending_restaurant_approval",
      "pendingRestaurantApprovals",
      "pending_restaurant_approvals",
    ],
  },
];

function Dashboard() {
  const [fromdate, setFromdate] = useState(null);
  const [todate, setTodate] = useState(null);
  const [showAppliedRange, setShowAppliedRange] = useState(false);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    try {
      const query = buildDashboardQuery(fromdate, todate);
      const url = query ? `${endpoints.dashboard}?${query}` : endpoints.dashboard;
      const response = await handleApiCall("get", url);

      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        setStats(response?.data?.data || {});
      }
    } catch (error) {
      console.error("Error fetching dashboard:", error);
    } finally {
      setLoading(false);
    }
  }, [fromdate, todate]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const getStatValue = (keys) => pickStat(stats, ...keys);

  const handleApplyDateRange = (start, end) => {
    setFromdate(start);
    setTodate(end);
    setShowAppliedRange(true);
  };

  const handleResetDateRange = () => {
    setFromdate(null);
    setTodate(null);
    setShowAppliedRange(false);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Dashboard</h3>
              <div className="text-end ms-auto">
                <DateRangeSelectButton
                  appliedFrom={fromdate}
                  appliedTo={todate}
                  onApply={handleApplyDateRange}
                  onReset={handleResetDateRange}
                />
              </div>
            </div>
            {showAppliedRange && fromdate && todate && (
              <p className="text-muted small mb-3">
                Showing data from {fromdate} to {todate}
              </p>
            )}
            <div className="row mx-n2">
              {STAT_CARDS.map((card) => (
                <div key={card.title} className="mb-4 mt-2 col-12 col-sm-6 col-lg-4 col-xl-3 px-2 d-flex">
                  <div
                    className="card dashboard-stat-card d-flex flex-column p-4 shadow-sm border w-100 h-100"
                    style={{ borderRadius: "10px" }}
                  >
                    <h5 className="dashboard-stat-card__title">{card.title}</h5>
                    <div className="dashboard-stat-card__value-row">
                      <h2 className="mb-0 text-primary">
                        {loading ? "—" : getStatValue(card.keys)}
                      </h2>
                      <img src={card.icon} alt="" className="dashboard-stat-card__icon" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
